









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SorewardsCoverageBar'
})
export default class extends Vue {
  @Prop({ required: true }) private value!: number
}
